import React, { useState, useRef } from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';
import { FaFacebook, FaGithub, FaLinkedin, FaTwitter, FaDiscord } from 'react-icons/fa';

function Contact() {
  const formRef = useRef();
  const [submitted, setSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_cossmej',      // Replace this
      'template_cy7h951',     // Replace this
      formRef.current,
      'SwbsECFylEXsCYqRS'       // Replace this
    )
    .then((result) => {
      console.log(result.text);
      setSubmitted(true);
    }, (error) => {
      console.log(error.text);
    });
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>📬 Contact Me</h1>
        <p className="contact-desc">Let's connect! Whether it's for a project, feedback, or just to chat.</p>

        <div className="contact-grid">
          {/* Left side: Info + Social */}
          <div className="contact-info">
            <h2>📇 Contact Info</h2>
            <p><strong>Name:</strong> Shigeo (Archie Berja)</p>
            <p><strong>Location:</strong> Parañaque City, Metro Manila</p>
            <p><strong>Email:</strong> <a href="mailto:archieberja01@gmail.com">archieberja01@gmail.com</a></p>

            <h3 style={{ marginTop: '1.5rem' }}>🔗 Socials</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/ritsu.kamado.2024/" target="_blank" rel="noopener noreferrer"><FaFacebook /> Facebook</a>
              <a href="https://github.com/RitsuKamado" target="_blank" rel="noopener noreferrer"><FaGithub /> GitHub</a>
              <a href="https://x.com/archieberja/" target="_blank" rel="noopener noreferrer"><FaTwitter /> Twitter</a>
              <a href="https://discord.com/invite/pdncu8aA" target="_blank" rel="noopener noreferrer"><FaDiscord /> Discord</a>
            </div>
          </div>

          {/* Right side: Form */}
           <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
            <h2>💬 Send a Message</h2>
            {submitted ? (
              <p className="thank-you">Thanks for your message! I’ll get back to you soon.</p>
            ) : (
              <>
                <input type="text" name="name" placeholder="Your Name" required />
                <input type="email" name="email" placeholder="Your Email" required />
                <textarea name="message" placeholder="Your Message" required></textarea>
                <button type="submit">Send Message</button>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
